module.exports = {
      "google_key": "G-DVY6718PMH",
      "heapanalytics_key": "1719419837"
    };